module.exports = __webpack_public_path__ + "static/media/img_4.92984d22.png";